import { MenuItem } from '../../models';

export const HABITS_VISUALIZER: MenuItem = { title: 'Study Visualizer', link: '/habits/visualizer' };

/** holds items for habits dropdown used in navbar */
export const HABITS_LIST: MenuItem[] = [{ title: 'Daily Practice Habits', link: '/habits/report' }, HABITS_VISUALIZER];
